import { render, staticRenderFns } from "./TermsPopup.vue?vue&type=template&id=56e3a9bc"
import script from "./TermsPopup.vue?vue&type=script&lang=js"
export * from "./TermsPopup.vue?vue&type=script&lang=js"
import style0 from "./TermsPopup.vue?vue&type=style&index=0&id=56e3a9bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports